




































































































































































































































































import { SwExtendedVue } from '../sw-extended-vue';
import { CSSStyleOptions }  from '../common-types';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { SwIconButton } from '../sw-icon-button';
import utilService from './util.service';
import { DateRangePane, DateRangeEle, SelectableDatesRangeType, DateTimePickerConfig } from './types';

@Component({
  components: {
    SwIconButton,
  },
})
export default class SwDatePicker extends SwExtendedVue {
  @Prop({ type: [String, Date], default: new Date() })
  value: string | Date;

  @Prop({ type: String, default: 'MM/DD/YYYY' })
  format: NonNullable<DateTimePickerConfig['dateFormat']>;

  @Prop({ type: Array, default() { return []; } })
  disabledDaysOfWeek: string[];

  @Prop({ type: Object, required: false })
  selectableDatesRange: SelectableDatesRangeType;

  @Prop({ type: Boolean, default: false })
  hidePreAndNextMonthDates: boolean;

  @Prop({ type: String, default: '200px' })
  width: string;

  @Prop(String)
  placeholder: string;

  @Prop({ type: Number, default: 1 })
  pane: number;

  @Prop({ default() {}, type: Function })
  changePane: Function;

  @Prop({ default() {}, type: Function })
  onDayClick: Function;

  @Prop({ type: Boolean, default: false })
  showDateOnly: boolean;

  @Prop({ type: Boolean, default: false })
  enableRange: boolean;

  cssPrefix = 'sw-datepicker';
  dateRange: DateRangePane[] = [];
  paneStyle: CSSStyleOptions = {
    width: '',
  };

  inputValue = this.value;
  currDate = new Date(); // currDate is Date format of inputValue.
  displayDayView = false;
  displayMonthView = false;
  displayYearView = false;

  selecting = false;
  rangeStart = this.parse(new Date());
  rangeEnd = this.parse(new Date());

  mounted() {
    this.currDate = this.parse(this.inputValue);
    this.updateDates();
    this.displayDayView = true;
    this.updatePaneStyle();
  }

  /**
   * FIX #23: block this dateView change when triggered by inputValue change. since it would cause clickOutside event
   * popperEl.contains(event.target) return false when select done at right pane.
   * Namely, only locate the selected date at view when mount this component.
   *  */
  updateDates(triggeredByMount: boolean = true) {
    const value = this.inputValue;
    if (typeof value === 'string' && value.includes('->') && this.enableRange) {
      if (triggeredByMount) {
        this.currDate = this.parse(value.split('->')[0]) || this.parse(new Date());
      }
      this.rangeStart = this.parse(value.split('->')[0]) || this.parse(new Date());
      this.rangeEnd = this.parse(value.split('->')[1]) || this.parse(new Date());
    } else if (typeof value === 'string' && !this.enableRange) {
      this.currDate = this.parse(value);
    }
  }

  /**
   * update dateView range and styles
  */
  @Watch('currDate')
  updateDateRange(selectedDate: Date) {
    this.getdates(selectedDate);
  }

  @Watch('value')
  updateValue(newVal: string) {
    this.inputValue = newVal;
    this.updateDates(false);
  }

  close () {
    this.selecting = false;
    this.displayDayView = this.displayMonthView = this.displayYearView = false;
  }

  updatePaneStyle () {
    if (!(this.displayMonthView || this.displayYearView)) {
      this.$nextTick(function () {
        const offsetLeft = (this.$el as HTMLElement).offsetLeft;
        let innerEle;
        if (this.$refs.popup) {
          innerEle = (this.$refs.popup as HTMLElement).querySelector('.sw-datepicker__popup__inner');
        }
        if (!innerEle) return;
        const offsetWidth = (innerEle as HTMLElement).offsetWidth;
        const popWidth = this.pane * offsetWidth;
        this.paneStyle.width = `${popWidth}px`;

        if (popWidth + offsetLeft > document.documentElement!.clientWidth) {
          this.paneStyle.right = '0px';
        }
        this.$forceUpdate();
      });
    }
  }

  parse (inputDate: string | Date, safe:Boolean = true) {
    if (typeof inputDate === 'string') {
      if (inputDate === '') return new Date();
      let date;
      // handle d/MM/yyyy alike case.
      const dateStr = inputDate.split('/')
        .map((e) => { if (e.length < 2) { return `0${e}`; } return e; })
        .join('/');
      if (dateStr.length === 10 && (this.format === 'DD-MM-YYYY' || this.format === 'DD/MM/YYYY')) {
        date = new Date(Number(dateStr.substring(6, 10)), Number(dateStr.substring(3, 5)) - 1, Number(dateStr.substring(0, 2)));
      } else {
        // MM/dd/yyyy || yyyy/MM/dd can be transformed automatically.
        date = new Date(dateStr);
        date.setHours(0, 0, 0);
      }
      return isNaN(date.getFullYear()) ? (safe ? new Date() : date) : date;
    }
    return inputDate;
  }

  siblingsMonth (v: Date, n: number) {
    return new Date(v.getFullYear(), v.getMonth() * 1 + n);
  }

  stringifyDayHeader (date: Date, month = 0) {
    const d = this.siblingsMonth(date, month);
    const monthStr = this.$t(utilService.getText().months[d.getMonth()])
      .toString();
    return `${monthStr.toUpperCase()} ${this.stringifyMonthHeader(date)}`;
  }

  stringifyMonthHeader(date: Date, year = 0) {
    return date.getFullYear() + year;
  }

  stringifyDecadeHeader (date: Date, pan: number) {
    const yearStr = date.getFullYear()
      .toString();
    const firstYearOfDecade = parseInt(yearStr.substring(0, yearStr.length - 1) + 0, 10) + (pan * 10);
    const lastYearOfDecade = parseInt(firstYearOfDecade.toString(), 10) + 10;
    return `${firstYearOfDecade}-${lastYearOfDecade}`;
  }

  get text() {
    return utilService.getText();
  }

  get isWrapperShow () {
    return this.displayDayView || this.displayMonthView || this.displayYearView;
  }

  preNextMonthClick (flag: number) {
    const year = this.currDate.getFullYear();
    const month = this.currDate.getMonth();
    const date = this.currDate.getDate();
    if (flag === 0) {
      const preMonth = utilService.getYearMonth(year, month - 1);
      this.currDate = new Date(preMonth.year, preMonth.month, date);
      // this.changePane(preMonth.year, preMonth.month, this.pane);
    } else {
      const nextMonth = utilService.getYearMonth(year, month + 1);
      this.currDate = new Date(nextMonth.year, nextMonth.month, date);
      // this.changePane(nextMonth.year, nextMonth.month, this.pane);
    }
  }

  preNextYearClick(flag: number) {
    const year = this.currDate.getFullYear();
    const month = this.currDate.getMonth();
    const date = this.currDate.getDate();
    if (flag === 0) {
      const preYear = utilService.getYearMonth(year - 1, month);
      this.currDate = new Date(preYear.year, preYear.month, date);
      // this.changePane(preYear.year, preYear.month, this.pane);
    } else {
      const nextYear = utilService.getYearMonth(year + 1, month);
      this.currDate = new Date(nextYear.year, nextYear.month, date);
      // this.changePane(nextYear.year, nextYear.month, this.pane);
    }
  }

  /** get classes of this date */
  getItemClasses (d: { date: Date, allowSelect: boolean, sclass: string }) {
    const clazzPrefix = 'sw-datepicker__dates__item';
    const clazz = [];
    clazz.push(d.sclass);
    if (this.enableRange && this.rangeStart && this.rangeEnd && d.sclass !== `${clazzPrefix}--gray`) {
      if (d.date > this.rangeStart && d.date < this.rangeEnd) {
        clazz.push(`${clazzPrefix}--range`);
      }
      if (this.stringify(d.date) === this.stringify(this.rangeStart) && this.stringify(d.date) === this.stringify(this.rangeEnd) && !this.selecting) {
        clazz.push(`${clazzPrefix}--same-dates-selected`);
      } else if (this.stringify(d.date) === this.stringify(this.rangeStart)) {
        clazz.push(this.selecting ? `${clazzPrefix}--start-in-selecting` : `${clazzPrefix}--start`);
      } else if (this.stringify(d.date) === this.stringify(this.rangeEnd)) {
        clazz.push(`${clazzPrefix}--end`);
      }
    }
    if (!d.allowSelect) {
      clazz.push(`${clazzPrefix}--disable`);
    }
    return clazz.join(' ');
  }

  parseMonth (date: Date) {
    return utilService.getText().months[date.getMonth()];
  }

  stringify(date: Date) {
    return utilService.stringify(date, this.format);
  }

  daySelect (item: {date: Date, allowSelect: boolean}, event: Event) {
    const date = item.date;
    const el = event.target as HTMLElement;
    if (!item.allowSelect || el.classList[0] === 'sw-datepicker__dates__item--disable') {
      return;
    }

    if (this.enableRange && !this.selecting) {
      this.handleDateSelect(date);
      this.rangeStart = date;
      this.rangeEnd = date;
      this.selecting = true;
      return;
    }
    if (this.enableRange && this.selecting) {
      // finally emit selected two dates.
      if (this.rangeStart <= this.parse(date)) {
        const dates = `${this.stringify(this.rangeStart)}->${this.stringify(date)}`;
        this.selecting = false;
        if (this.onDayClick) {
          this.onDayClick(date, this.stringify(date));
        }
        this.$emit('input', dates);
      }
      return;
    }

    if (!this.enableRange) {
      // single Date mode.
      this.currDate = date;
      this.handleDateSelect(date);
      this.$emit('input', this.stringify(date));
    }
  }
  // call onDayClick.
  handleDateSelect(date: Date) {
    if (!this.onDayClick || this.onDayClick === function () {}) return date;
    this.onDayClick(date, this.stringify(date));
    return date;
  }

  dayHover(dateEle: DateRangeEle) {
    if (this.enableRange && this.selecting) {
      // set rangeEnd as this date.
      if (this.rangeStart <= this.parse(dateEle.date)) {
        this.rangeEnd = dateEle.date;
      }
    }
  }

  switchMonthView () {
    if (this.showDateOnly) {
      return true;
    }
    this.displayDayView = false;
    this.displayMonthView = true;
  }
  switchDecadeView () {
    this.displayMonthView = false;
    this.displayYearView = true;
  }
  monthSelect (year: number, index: number) {
    this.displayMonthView = false;
    this.displayDayView = true;
    this.currDate = new Date(year, index, this.currDate.getDate());
    // this.changePane(year, index, this.pane);
  }

  monthSelected(month: string, pane: number) {
    if (pane > 0) return '';
    if (utilService.getText().months[this.currDate.getMonth()]  === month) {
      return 'sw-datepicker__months__item--active';
    }
  }

  // getdates by currDate, and update DateView styles.
  getdates (currDate: Date) {
    const cssPrefix = 'sw-datepicker__dates__item';
    this.dateRange = [];
    for (let p = 0; p < this.pane; p += 1) {
      const currMonth = this.siblingsMonth(currDate, p);
      const time = {
        year: currMonth.getFullYear(),
        month: currMonth.getMonth(),
      };
      // declare a temp Arr..
      const currDates: DateRangeEle[] = [];
      const currMonthFirstDay = new Date(time.year, time.month, 1);
      let firstDayWeek = currMonthFirstDay.getDay() + 1;
      if (firstDayWeek === 0) {
        firstDayWeek = 7;
      }
      const dayCount = utilService.getDayCount(time.year, time.month);
      if (firstDayWeek > 1) {
        const preMonth = utilService.getYearMonth(time.year, time.month - 1);
        const prevMonthDayCount = utilService.getDayCount(preMonth.year, preMonth.month);
        for (let i = 1; i < firstDayWeek; i += 1) {
          const dayText = prevMonthDayCount - firstDayWeek + i + 1;
          currDates.push({
            text: dayText,
            date: new Date(preMonth.year, preMonth.month, dayText),
            sclass: this.hidePreAndNextMonthDates ? `${cssPrefix}--hidden` : `${cssPrefix}--gray`,
            allowSelect: true,
          });
        }
      }
      for (let i = 1; i <= dayCount; i += 1) {
        const date = new Date(time.year, time.month, i);
        const index = date.getDay();
        let sclass = '';
        let allowSelect = true;
        this.disabledDaysOfWeek.forEach((el: string) => {   // disabledDaysOfWeek style
          if (index === parseInt(el, 10)) {
            sclass = `${cssPrefix}--disable`;
            allowSelect = false;
          }
        });
        const inputDate = this.parse(this.inputValue);
        if (inputDate.getDate() === i &&
            inputDate.getFullYear() === time.year &&
            inputDate.getMonth() === time.month) {
          sclass = this.enableRange ? `${cssPrefix}--current` : `${cssPrefix}--active`;  // current date style or active date style.
        }
        if (this.selectableDatesRange) {
          if (this.selectableDatesRange.startDate) {
            const startDate = this.parse(this.selectableDatesRange.startDate);
            if (startDate.getTime() > date.getTime()) {
              sclass = `${cssPrefix}--disable`;
              allowSelect = false;
            }
          }
          if (this.selectableDatesRange.endDate) {
            const endDate = this.parse(this.selectableDatesRange.endDate);
            if (endDate.getTime() < date.getTime()) {
              sclass = `${cssPrefix}--disable`;
              allowSelect = false;
            }
          }
        }
        currDates.push({
          date,
          sclass,
          allowSelect,
          text: i,
        });
      }
      if (currDates.length < 42) {
        const nextMonthNeed = 42 - currDates.length;
        const nextMonth = utilService.getYearMonth(time.year, time.month + 1);
        for (let i = 1; i <= nextMonthNeed; i += 1) {
          currDates.push({
            text: i,
            date: new Date(nextMonth.year, nextMonth.month, i),
            sclass: this.hidePreAndNextMonthDates ? `${cssPrefix}--hidden` : `${cssPrefix}--gray`,
            allowSelect: true,
          });
        }
      }
      this.dateRange.push({
        dates: currDates,
      });
    }
  }
}
